import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EmailResult } from '@core/enums';
import { SelectionOption } from '@core/models';
import { HelpAndFeedback } from '@core/models/help-and-feedback/help-and-feedback.model';
import { LayoutService, NotificationService, SnackbarService } from '@core/services';
import { ContactAdminComponent } from '@modules/dialogs/contact-admin/contact-admin.component';
import { getInitials } from '@shared/helpers';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpComponent implements OnInit {
  static readonly componentName = 'HelpComponent';
  
  @Input() helpAndFeedback: {sysText: any, helpInfo: HelpAndFeedback};
  @Output() closeHelp = new EventEmitter<void>();

  public getInitials = getInitials;

  get isMobile$(): Observable<boolean> {
    return this.layoutService.isMobile$();
  }
  
  constructor(
    private layoutService: LayoutService,
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
  }

  public onCloseHelp(): void {
    this.closeHelp.emit();
  }

  public contactAdmin(admin: SelectionOption): void {
    const dialogConfig: MatDialogConfig = {
      id: ContactAdminComponent.componentName,
      width: '500px',
      data: {
        admin: admin,
        sysText: this.helpAndFeedback.sysText
      }
    };
    
    this.dialog.open(ContactAdminComponent, dialogConfig)
      .afterClosed()
      .pipe(filter((res) => !!res))
      .subscribe((res: EmailResult) => {
        if (res == EmailResult.success) {
          let snackText = this.helpAndFeedback.sysText.contactAdminWithEmailSuccess;
          this.snackbarService.open(snackText, this.helpAndFeedback.sysText.dismiss);
        }
        else if (res == EmailResult.successWithFailure) {
          let toastText = this.helpAndFeedback.sysText.contactAdminWithEmailSuccessFailure;
          this.notificationService.showErrorToast(toastText);
        }
        else {
          let toastText =  this.helpAndFeedback.sysText.contactAdminFailure;
          this.notificationService.showErrorToast(toastText);
        }
      });
  }

}
